import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { IconButton, Tooltip } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export default function StepBackButton({stepBackward, firstStep}) {
    return (
        <div className="wrapper" id='stepBackwardWrapper'>
            <Tooltip title="Letzter Abschnitt" TransitionComponent={Zoom} arrow>
                <IconButton
                    color="primary"
                    onClick={stepBackward}
                    disabled={firstStep}
                >
                    <KeyboardDoubleArrowLeft />
                </IconButton>
            </Tooltip>
        </div>
    );
} 